module.exports = __webpack_public_path__ + "static/img/hair_06.cd7788c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_06.png
// module id = 4eS9
// module chunks = 0